export default {
	"dataTransfer.loading.title": "Ihre Anfrage wird gerade bearbeitet",
	"dataTransfer.loading.description":
		"Dieser Vorgang kann einige Minuten dauern, bitte haben Sie etwas Geduld.",
	"dataTransfer.loading.processed": "Verarbeitet",
	"dataTransfer.loading.from": "von",
} as const;
